import type { LinkOverlayProps } from "@chakra-ui/react";
import { Box } from "@chakra-ui/react";
import type { MouseEventHandler } from "react";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";

export interface CustomLinkOverlayProps extends LinkOverlayProps {
    to: string;
}

// Nelze použít LinkOverlay z Chakra UI, protože neumí otevírat nové okno při stisknutí klávesy Ctrl nebo Meta
// A také z něho nelze vybírat a kopírovat text
export const CustomLinkOverlay = ({ to, children, ...props }: CustomLinkOverlayProps) => {
    const navigate = useNavigate()
    const isMouseDown = useRef(false)

    const handleClick: MouseEventHandler<HTMLElement> | undefined = (event) => {
        if (event?.button === 2) return;

        if (event?.target instanceof HTMLAnchorElement || event?.target instanceof HTMLButtonElement)
            return;

        event?.preventDefault();

        if (event?.metaKey || event?.ctrlKey || event?.button === 1) {
            const baseUrl = window.location.origin + (import.meta.env.VITE_BASE_URL || '');
            window.open(baseUrl + to, '_blank');
        }
        else {
            navigate(to);
        }
    }

    // handleMouseDown and handleMouseUp dismisses the auto-scroll mode when mouse wheel is clicked.
    const handleMouseDown: MouseEventHandler<HTMLElement> | undefined = (event) => {
        if (event.button === 1) {
            event?.preventDefault()
            isMouseDown.current = true;
        }
    }

    const handleMouseUp: MouseEventHandler<HTMLElement> | undefined = (event) => {
        if (isMouseDown.current && event.button === 1) {
            isMouseDown.current = false;
            handleClick(event);
        }
    }

    return (
        <Box onClick={handleClick} onMouseDown={handleMouseDown} onMouseUp={handleMouseUp} cursor='pointer' {...props}>
            {children}
        </Box>
    );
};